<template>
  <div class="personalCenter" v-loading="isLoading" element-loading-background="rgba(255, 255, 255, 1)">
      <div class="topbar">
          <div class="content myflex-v topbarInnerBox">
              <!-- <span class="backBtn" @click="back"><i class="el-icon-back backIcon"></i> 返回</span> -->
              <el-button size="mini" class="backIconBox" @click="back"><i class="el-icon-back backIcon"></i> 返回</el-button>
              <div class="flex1">
                <div class="topbarFont1">全民终身学习教育资源共享行动 &nbsp; 社区艺术教育师资共享库</div>
                <div class="topbarFont2">社区艺术教育师资胜任力符合教育部社区艺术教育制度化规范化研究与实践项目标准</div>
              </div>
          </div>
      </div>
    <div class="main">
        <div class="topInfoBox">
            <div class="myflex-v mb20 topInfoInerBox">
                <div class="mr15 myflex-v">
                    <div class="userPho mr10" :style="'background:url(' + userInfo.photoPath || defaultPhoto + ') center'"></div>
                    <div>
                        <div class="userName">{{ realNameInfo ? realNameInfo.realName : info.userName }}</div>
                        <div class="labelRealname">
                            <span class="showRealname mr10" v-if="realNameInfo">已实名</span>
                            <span class="showRealname mr10" v-else>未实名</span>
                            <span class="label mr10" v-if="info.identityLabel">{{info.identityLabel}}</span>
                            <span class="label babel1 mr10" v-if="info.volunteerLabel">{{info.volunteerLabel}}</span>
                        </div>
                    </div>
                </div>
                <div class="marginauto-l myflex-v btnBox">
                    <span class="topActBtn myflex-lv mr15" @click="toEditUserInfo"><i class="el-icon-edit topActIcon"></i>编辑个人资料</span>
                    <span class="topActBtn myflex-lv" @click="logout"><i class="el-icon-upload2 topActIcon quitIcon"></i>退出登录</span>
                </div>
            </div>
            <div>
                <div class="mb10">账号：{{ userInfo.mobile }}</div>
                <div class="mb15">所在工作室：{{ info.studioName }}</div>
                <div class="mb10">专业：<span class="majorItem" v-for="(mItem,mIndex) in info.majors" :key="mIndex">{{mItem.majorName}}</span></div>
            </div>
        </div>
        <div class="mainBox">
            <div v-if="false" class="toApplyRow mb20">实名认证和上传相关证书后，可点击进行美育教师升级<span class="toApplyBtn" @click="toApply">去申请</span></div>
            <div class="secBox">
                <div class="myflex-v mb20">
                    <div class="mySecTitle">素养提升之路（证书）</div>
                    <div class="marginauto-l" @click="toUpCert"><el-button type="primary" size="medium">上传证书</el-button></div>
                </div>
                <div v-loading="loading1" class="listOutBox">
                    <template v-if="certList && certList.length">
                        <div class="myflex flexWrap certBoxItemBox">
                            <div class="certBoxItem upCertBtn myflex-lv myhide" @click="toUpCert">
                                <div class="text-center">
                                    <img src="@/assets/img/upIcon.png" alt="" />
                                    <div>上传证书</div>
                                </div>
                            </div>
                            <div class="certBoxItem" v-for="(item, index) in certList" :key="index" >
                                <div class="certImg myflex flexDirection-col" style="background:url() center no-repeat" @click="preCert(item.certificate, item)">
                                    <img class="certTopImg" src="@/assets/img/center/certTop.png" alt=""/>
                                    <div class="certName myflex-lv flex1"><div class="ellipsis2">{{ item.certificateName }}</div></div>
                                    <div v-if="item.certificateStatus == 1" class="shIng myflex-lv">
                                        <img src="@/assets/img/sh.png" class="shIngImg" alt="" />
                                    </div>
                                </div>
                                <div class="botTitle mt10 text-center"><div class="ellipsis2">{{ item.certificateName }}</div></div>
                            </div>
                        </div>
                        <div class="elPageBox" v-show="total>0">
                            <el-pagination
                                background
                                :pager-count="5"
                                @current-change="currentChange"
                                :current-page.sync="pageNum"
                                :page-size="pageSize"
                                layout="prev, pager, next"
                                :total="total">
                            </el-pagination>
                        </div>
                    </template>
                    <div v-else class="noData myflex-lv">
                        <el-empty description="暂无数据" :image-size="90"></el-empty>
                    </div>
                </div>
            </div>

            <div class="secBox">
                <ReportList />
            </div>

             <div class="secBox">
                <div class="myflex-v mb20">
                    <div class="mySecTitle">个人风采</div>
                    <div class="marginauto-l" @click="triggerSelectFile"><el-button type="primary" size="medium">上传个人风采</el-button></div>
                </div>
                <div v-loading="loading2" class="listOutBox">
                    <div v-show="fcList && fcList.length">
                        <div class="myflex flexWrap fcBoxItemBox">
                            <div class="certBoxItem upCertBtn myflex-lv myhide" @click="toUpCert">
                                <div class="text-center">
                                    <img src="@/assets/img/upIcon.png" alt="" />
                                    <div>上传证书</div>
                                </div>
                            </div>
                            <div>
                                <Upload
                                    ref="upload"
                                    :hideTriggerBtn="true"
                                    :filelist="fcList"
                                    folder="teacher_shine_attachs"
                                    :upVideoDuration="true"
                                    :upVideoCover="true"
                                    :deleteDirectly="false"
                                    :unshift="true"
                                    type="video,audio"
                                    @on-success="onFcSuccess"
                                    @on-delete="onFcDelete"
                                />
                            </div>
                        </div>
                        <div class="elPageBox" v-show="total_fc>0">
                            <el-pagination
                                background
                                :pager-count="5"
                                @current-change="currentChange_fc"
                                :current-page.sync="pageNum_fc"
                                :page-size="pageSize_fc"
                                layout="prev, pager, next"
                                :total="total_fc">
                            </el-pagination>
                        </div>
                    </div>
                    <div v-show="!fcList || !fcList.length" class="noData myflex-lv">
                        <el-empty description="暂无数据" :image-size="90"></el-empty>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 上传证书 -->
    <el-dialog
      title="上传证书"
      :visible.sync="dialogVisible"
      width="30%" custom-class="upCertModal"
      :close-on-click-modal="false"
    >
      <div>
        <el-form
          ref="form"
          :model="form"
          label-position="left"
          label-width="130px"
        >
          <el-form-item label="证书名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="上传证书图片">
            <div>
              <Upload
                :filelist="fileList"
                type="image"
                folder="certificate/studio"
                :limit="1"
              />
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <!--编辑账号信息 -->
    <el-dialog
      title="编辑账号信息"
      :visible.sync="userInfoDialogVisible"
      width="400px"
      :close-on-click-modal="false"
    >
      <div>
        <el-form label-position="left" label-width="80px">
          <el-form-item label="昵称">
            <el-input v-model="nick"></el-input>
          </el-form-item>
          <el-form-item label="头像">
            <div>
              <Upload
                :filelist="fileList1"
                type="image"
                folder="user/photo"
                :limit="1"
              />
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit1">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <!--查看大图 -->
    <el-dialog
      title="预览"
      :visible.sync="showImgDialogVisible"
      width="80%"
      :close-on-click-modal="true"
    >
      <div class="w-100 myflex-lv">
        <img :src="curPreImgUrl" alt="" class="curPreImg">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import base from '@/api/base.js';
import checkLogin from '@/utils/checkLogin.js';
import ReportList from './ReportList.vue';
import Upload from '@/components/Upload.vue';
import { Form, FormItem, Input, Button, Radio, RadioGroup, Dialog } from 'element-ui';
import {
  mapState,
  mapMutations
} from 'vuex';

export default {
  name: "login",
  components: {
    [Input.name]: Input,
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Dialog.name]: Dialog,
    Upload,
    ReportList,
  },
  data() {
    return {
        isLoading: true,
      dialogVisible: false,
      form: {
        name: '',
      },
      fileList: [],
      certList: [],
      pageNum:1,
      pageSize:12,
      total: 0,
      loading1: true,
      //userInfo: this.$store.state.userInfo,
      token: '',
      realNameInfo: null,

      userInfoDialogVisible: false,
      nick: '',
      fileList1: [],

      showImgDialogVisible: false,
      curPreImgUrl: '',
      isShareSite: 0,
      info: {},
      defaultPhoto: art.addOssResize(art.defaultHeadPhoto,120),

      fcList: [],
      pageNum_fc:1,
      pageSize_fc:999,
      total_fc: 0,
      loading2: true,
    }
  },
  watch: {
  },
  computed: mapState(['userInfo']),
  beforeCreate(){
      //缓存里没有userInfo就退出登录
    //   var userInfo = JSON.parse(localStorage.getItem('userInfo'));
    //   if(!userInfo || !userInfo.token){
    //       checkLogin.checkLogin('login');
    //       return false;
    //     }
  },
  created() {
      //store里没有userInfo就退出登录
      if(!this.userInfo || !this.userInfo.token){
          checkLogin.checkLogin('login');
          return false;
      }
        this.isLoading = this.userInfo && this.userInfo.token ? false : true;
      let isShareSite = this.$route.query.isShareSite;
    if (isShareSite) {
      this.isShareSite = isShareSite;
      console.log(this.isShareSite,'this.isShareSite');
    }
    
    this.nick = this.userInfo.userName;
    this.fileList1 = [{ ossurl: this.userInfo.photoPath, cover: this.userInfo.photoPath }];
    this.userGetUserInfo();
    setTimeout(()=>{
        this.getReportList();
    },150)
    setTimeout(()=>{
        this.getTeacherShineAttachList();
    },300)
    this.getRealNameInfo();
  },
  mounted() {

  },
  methods: {
    ...mapMutations(['signOut']),

    toApply() {
      window.open(base.applyUrl2, '_blank')
    },

    getRealNameInfo() {
      const that = this;
      let params = {
        token: this.userInfo.token
      }
      that.$api.mainApi.getRealNameInfo(params,'errorNotTips').then(res => {
        let result = res.body.realNameInfo;
        this.realNameInfo = result
        if(!result){
            that.$router.push({ path: "/realInfo" });
        }
      }).catch(error => {
        //that.$message.error(error.msg);
      })
    },

    userGetUserInfo(){
        var vm = this;
        var data = { token: vm.userInfo.token }
        this.$api.mainApi.userGetUserInfo(data).then(res => {
            vm.info = res.body.userInfo;
        }).catch(res=>{
            console.log(res,'res')
            if(res.code=='901'){
                checkLogin.checkLogin('login');
            }
        })
    },

    //查询成绩报告
    getReportList(num) {
      var vm = this;
      vm.loading1 = true;
      var pageNum = num ? num : vm.pageNum;
      var data = { 
          token: vm.userInfo.token,
          pageNum:pageNum,
          pageSize: vm.pageSize,
    }
      this.$api.mainApi.getUserCertificateList(data,'errorNotTips').then(res => {
        vm.pageNum = pageNum;
        vm.total = res.body.total;
        var d = res.body.userCertificates;
        if (res.success && d && d.length) {
          var arr = d ? d : [];
          for (var i in arr) {
            arr[i].showImg = arr[i].certificate ? art.addOssResize(arr[i].certificate, 160) : require('@/assets/img/certDefaultImg.png');
          }
          vm.certList = arr;
        } else {
          vm.certList = [];
        }
        vm.loading1 = false;
      }).catch(res=>{
          vm.loading1 = false;
      })
    },

    currentChange(num){
        this.getReportList(num);
    },

    preCert(img, obj) {
      var vm = this;
      if(img){
          vm.preImg(art.addOssurlHeader(img));
      }else{
          var data = { token: vm.userInfo.token, source: obj.source, sourceId: obj.sourceId }
        this.$api.mainApi.getUserCertificateDetail(data).then(res => {
            console.log(res);
            vm.preImg(art.addOssurlHeader(res.body.userCertificate.certificate));
        })
      }
      
    },

    inputChange() {

    },

    toUpCert() {
      this.dialogVisible = true;
    },

    onSubmit() {
      let vm = this;
      let d = vm.form;
      let f = vm.fileList;
      for (var i = 0; i < f.length; i++) {
        if (f[i].upStatus == 'upIng') {
          vm.$message.error('视频中正在上传中,请稍后!');
          return;
        }
        if (f[i].upStatus == 'upErr') {
          vm.$message.error('上传失败，请重新上传');
          return;
        }
      }
      if (!d.name) {
        vm.$message.error('请输入证书名称!');
        return;
      }
      let certImg = f[0].ossurl;
      console.log(f, 'f');
      let data = {
        token: vm.userInfo.token,
        certificateName: d.name,
        certificate: certImg,
      }
      console.log(data, 'data');
      this.$api.mainApi.uploadCertificate(data).then(res => {
        if (res.success) {
            this.$alert('', '已上传成功，后台审核后将生效。', {
            confirmButtonText: '确定',
            type: 'success',
            center: true,
            callback: action => {}
            })
          vm.form = {
            name: '',
          }
          vm.fileList = [];
          vm.getReportList();
          vm.dialogVisible = false;
        }
      }).catch(res => {
        vm.$message.error('保存失败!');
      })
    },

    //编辑个人信息
    toEditUserInfo() {
        //this.userInfoDialogVisible = true;
        this.$router.push({path:'/editUserInfo'});
    },
    onSubmit1() {
      let vm = this;
      let f = vm.fileList1;
      for (var i = 0; i < f.length; i++) {
        if (f[i].upStatus == 'upIng') {
          vm.$message.error('头像中正在上传中,请稍后!');
          return;
        }
        if (f[i].upStatus == 'upErr') {
          vm.$message.error('上传失败，请重新上传');
          return;
        }
      }
      if (!vm.nick) {
        vm.$message.error('请输入证书名称!');
        return;
      }
      let certImg = f[0].ossurl;
      let data = {
        userName: vm.nick,
        photoPath: certImg,
        token: vm.userInfo.token,
      }
      this.$api.mainApi.updateLoginInfo(data).then(res => {
        if (res.success) {
          vm.$message('保存成功!');
          vm.nick='';
          vm.fileList1 = [];
          let result = res.body.userInfo;
          vm.saveUserInfo(result);
          vm.userInfoDialogVisible = false;
        }
      }).catch(res => {
        vm.$message.error('保存失败!');
      })
    },
    saveUserInfo(data){
      const that = this;
      let changeUserInfo = that.userInfo;
      changeUserInfo.userName = data.username;
      changeUserInfo.photoPath = art.addOssurlHeader(data.photoPath);
      that.$store.state.userInfo=changeUserInfo;
      localStorage.setItem('userInfo',JSON.stringify(changeUserInfo));
    },
    //退出登录
    logout() {
        this.$signOut.signOut(base.eduUlr);
    },

    back(){
        var vm = this;
        var token = vm.userInfo.token;
        this.$router.replace({path:'/'})
        return;
        //history.back();
        if(this.isShareSite==1){
            var url = base.shareSiteUrl;
            if(token) url = url+'?token='+token;
            location.replace(url);
        }else{
            history.back();
        }
    },

    preImg(url){
        this.curPreImgUrl = url;
        this.showImgDialogVisible = true;
    },

    //查询风采
    getTeacherShineAttachList(num) {
        var vm = this;
        vm.loading2 = true;
        var pageNum = num ? num : vm.pageNum_fc;
        var data = {
            token: vm.userInfo.token,
            pageNum:pageNum,
            pageSize: vm.pageSize_fc,
        }
        this.$api.mainApi.getTeacherShineAttachList(data,'errorNotTips').then(res => {
            vm.pageNum_fc = pageNum;
            vm.total_fc = res.body.total;
            var fc = res.body.dataList;
            for (var j in fc) {
                fc[j].type = calcType(fc[j].minetype);
                fc[j].ossurl = fc[j].catalog +'/'+ fc[j].filename +'.'+ fc[j].extension;
                fc[j].cover = fc[j].type=='image' ? art.addOssResize(fc[j].ossurl,200) : (fc[j].thumb ? art.addOssResize(fc[j].thumb,200) :require('@/assets/img/defaultCover.png'));
            }
            vm.fcList = fc;
            function calcType(str){
                if(str=='视频') return 'video';
                if(str=='音频') return 'audio';
                if(str=='图片') return 'image';
                return '';
            }
            vm.loading2 = false;
        }).catch(res=>{
            vm.loading2 = false;
        })
    },

    currentChange_fc(num){
        this.getTeacherShineAttachList(num);
    },

    //风采上传成功
    onFcSuccess(a,b){
        console.log('上传成功');
        console.log(a,b);
        var vm = this;
        a.upStatus = 'upIng';
        var data = {
            catalog: a.catalog,
            extension: a.extension,
            filename: a.filename,
            minetype: a.minetype,
            //thumb: a.thumb,
            token: vm.userInfo.token,
        }
        if(a.duration) data.duration = vm.$utils.toFixed(a.duration,0);
        if(a.thumb) data.thumb = a.thumb;
        vm.$api.mainApi.userAddTeacherShine(data).then(res => {
            vm.$message('添加成功');
            a.upStatus = 'upSuc';
            a.id = res.body.id;
            console.log(a,'aaaa');
        }).catch(res=>{
            a.upStatus = 'upErr';
        })
    },

    //删除风采
    onFcDelete(a,index){
        console.log(a,index)
        var vm = this;
        vm.$confirm( '确定删除吗？','artapp提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            if(a.id){
                var data = {
                    id: a.id,
                    token: vm.userInfo.token,
                }
                vm.$api.mainApi.userDelTeacherShine(data).then(res => {
                    vm.$message('删除成功');
                    vm.fcList.splice(index,1);
                }).catch(res=>{
                    vm.$message.error('操作失败');
                })
            }else{
                vm.fcList.splice(index,1);
            }
            
        }).catch(() => {
                  
        });
        
    },

    triggerSelectFile(){
        console.log(this.$refs.upload.triggerSelectFile);
        this.$refs.upload.triggerSelectFile();
    },

  },
};
</script>

<style lang="scss" scoped>
    .backBtn {color: #666;cursor:pointer;}
    .backBtn:hover {color: $theme-color;}
    .backBtn:hover .backIcon {color: $theme-color;}
    .main {margin: 20px auto;max-width: 1200px;}
    .mainBox {background: #ffffff;box-shadow: 0px 0px 23px 0px rgba(0, 0, 0, 0.08);padding: 20px 30px;}
    .userPho {@include headphoto(46px);min-width:46px;}
    .upCertBtn {width: 160px;height: 200px;border-radius: 4px;border: 1px solid #ddd;}
    .certBoxItemBox{margin:0 -12.5px;}
    .certBoxItem {width:169px;margin: 0 12.5px 20px 12.5px;}
    .certImg {height:200px;background-size: cover !important;
        border-radius: 4px;position: relative;border: 3px solid #E3F4FF;}
    .certTopImg{width:100%;}
    .shIng {position: absolute;top: 0;left: 0;width: 100%;height: 100%;background: rgba(0, 0, 0, 0.3);}
    .shIngImg {height: 60px;}
    .certName {line-height: 1.4;text-align: center;color:#0D88D3;font-weight:600;padding:5px 8px;}
    .toApplyRow {background: rgba(246, 179, 127, 0.2);border: 1px solid #ffcfab;border-radius: 11px;padding: 8px 10px;}
    .toApplyBtn {color: #cb531d;cursor: pointer;}
    .toApplyBtn:hover {text-decoration: underline;}

    .actFont {color: #0082d1;cursor: pointer;}
    .actFont:hover {text-decoration: underline;}
    .curPreImg{max-width:100%;}
    .mySecTitle{font-size:18px;font-weight:600;margin:10px 0 10px 0 !important;}
    .mySecTitle::before{content:'';background: #0d88d3;}
    .personalCenter{background: #fafafa;min-height: 100vh;}
    .topbar{text-align:center;background:#fff;padding:35px 15px 25px 15px;-webkit-box-shadow:1px 0 4px rgba(0, 0, 0, 0.08);}
    .topbarFont1{color:#333;font-size:24px;margin-bottom:10px;}
    .topbarFont2{color:#848484;font-size:16px;}

    .topInfoBox{@include bg-img('../../assets/img/center/bg.png');padding:20px;color:#fff;}
    .topActBtn{border:1px solid #fff;background:rgba(255,255,255,.1);color:#fff;font-size:14px;border-radius:6px;padding:5px 10px;cursor:pointer;}
    .topActBtn:hover{background:rgba(255,255,255,.3);}
    .topActIcon{color:#fff;margin-right:3px;font-size:16px;}
    .quitIcon{-webkit-transform:rotate(90deg);transform:rotate(90deg);}
    // .labelRealname{border-radius:30px;overflow:hidden;}
    .label{color:#4E2F13;background-image:linear-gradient(0deg, #FDEC96, #FFD872);padding:4px 10px;display:inline-block;border-radius:30px;}
    // .babel1{background:#f4624e;}
    .showRealname{color:#FFDC79;background:#4E2F13;padding:4px 10px;display:inline-block;border-radius:30px;}
    .userName{font-size:16px;margin-bottom:7px;}
    .majorItem{line-height:1;padding:3px 6px;font-size:14px;color:#fff;margin-right:8px;background:rgba(255,255,255,.2);border-radius:1px;}
    .botTitle{min-height:20px;}
    .elPageBox ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active{background-color: #409EFF !important;}
    .elPageBox ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active:hover{color:#fff !important;}
    .elPageBox ::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover{color: #409EFF !important;}
    @media screen and(max-width:900px){
        .main{margin:0 auto;}
        .mainBox{padding:20px 25px;}
        .topbarInnerBox{display:block;}
        .topbar{text-align:left;}
        .backIconBox{margin-bottom:15px;}
        .certBoxItem{width:150px;}
        .certImg{height:180px;}
        .upCertBtn{height:180px;}
    }
    @media screen and(max-width:600px){
        .topInfoInerBox{display:block !important;}
        .btnBox{margin:15px 0 15px 0;}
    }
    .secBox{margin-bottom:30px;}
    .fcBoxItemBox{margin:0 -12.5px;}
    .fcBoxItemBox ::v-deep .upFileBox{width:208px;height:160px;margin:0 12.5px 20px 12.5px;}
    .listOutBox{min-height:217px;}
    .noData{width:100%;height:100%;text-align:center;color:#999;}
</style>
<style lang="scss">
    .personalCenter .upCertModal{width:90% !important;max-width:600px !important;}
    @media screen and(max-width:800px){
    .personalCenter{
        .el-form-item .el-form-item__label{float:none;}
        .el-form-item .el-form-item__content{margin-left:0px !important;width:100%;}
        .upFileBox{width:120px;height:120px;}
    }
}
</style>
